import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../../api';
import '../types';
import { MaterialPrice } from '../types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getMaterialPriceDetail: builder.query<MaterialPrice, PayloadRequest>({
      query: (data) => ({
        url: `/v1/MaterialPrice/${data.id}`,
      }),
    }),
    changeMaterialPrice: builder.mutation<void, MaterialPrice>({
      query: (data) => ({
        url: `/v1/MaterialPrice/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createMaterialPrice: builder.mutation<void, MaterialPrice>({
      query: (data) => ({
        url: '/v1/MaterialPrice',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useChangeMaterialPriceMutation,
  useCreateMaterialPriceMutation,
  useGetMaterialPriceDetailQuery,
  useLazyGetMaterialPriceDetailQuery,
} = request;
